<template>
  <div class="mobile-header">
    <div class="mobile-header-title">
      <img v-if="path == '/'" class="logo" :src="infoList.websiteLogo" />
      <img v-if="infoList.footerLogo && path != '/'" class="logo" :src="infoList.footerLogo" />
      <div v-else></div>
      <img class="nav-img" src="../../static/images/nav.png" @click="show = true" />
    </div>
    <div class="mobile-header-box" :class="show == true ? 'show-active' : ''">
      <div class="div">
        <div class="mobile-header-ul">
          <div @click="toIndex">首页</div>
          <div v-for="(item, index) in list" :key="index" @click="toPage(index)">
            <p v-if="item.menuShow == 1">
              {{ item.menuName }}
            </p>
          </div>
        </div>
        <div class="mobile-header-clone"><img @click="show = false" src="../../static/images/clone.png" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import {menuList} from '@/api/xx-index'
import {infoList} from '@/api/index'
export default {
  data() {
    return {
      list: [],
      show: false,
      path: '',
      infoList: {}
    }
  },
  created() {
    this.menuListx()
    console.log('这是路由参数', this.$route.path)
    this.path = this.$route.path
  },
  methods: {
    menuListx() {
      menuList({deptId: 112}).then(res => {
        console.log(res)
        this.list = res
      })
      infoList({deptId: 112}).then(res => {
        console.log(res)
        this.infoList = res
      })
    },
    //去首页
    toIndex() {
      this.$router.push('/')
    },
    //页面跳转
    toPage(index) {
      this.$router.push(this.list[index].template.templateUrl + '?id=' + this.list[index].id)
    }
  }
}
</script>

<style></style>
